export enum Breakpoint {
  sm = 875,
  lg = 1200,
}

export const BREAKPOINTS = [Breakpoint.sm, Breakpoint.lg];
